import { userConstants } from "../../constant";

const initialState = {
  returns: [],
};

export function buyerReturns(state = initialState, action) {
  switch (action.type) {
    case userConstants.GET_BUYER_RETURNS:
      return { ...state, returns: action.returns };

    case userConstants.CREATE_RETURN_REQUEST:
      return {
        ...state,
        returns: [action.return_request, ...state.returns],
      };

    default:
      return state;
  }
}
